<template>
  <div class="statisticsPage">
    <van-tabs v-model="projectStatus" swipeable>
      <van-tab title="类型" name="projectType">
        <div class="typeInfo">
          <div class="selectMain clearfix">
            <span> 仅统计独立未作废项目</span>
            <p class="radioInfo">
              <span
                :class="radioType == 'all' ? 'radioItem' : ''"
                @click="changeType('all')"
                >全部</span
              >
              <span
                :class="radioType == 'year' ? 'radioItem' : ''"
                @click="changeType('year')"
                >当年</span
              >
            </p>
          </div>
          <div class="infoMain">
            <div class="pieMian" v-if="echartData && echartData[0]">
              <pie-echarts :pieData="pieData"></pie-echarts>
            </div>
            <div v-else class="nonePage">
              <img :src="baseUrl + 'empty.png'" alt />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="区域" name="projectRanking">
        <div class="rankInfo">
          <div class="selectMain clearfix">
            <span> 仅统计独立未作废项目</span>
            <p class="radioInfo">
              <span
                :class="rankType == 'all' ? 'radioItem' : ''"
                @click="changeRank('all')"
                >全部</span
              >
              <span
                :class="rankType == 'year' ? 'radioItem' : ''"
                @click="changeRank('year')"
                >当年</span
              >
            </p>
          </div>
          <div class="rank-ul">
            <div v-if="dataList.length != 0">
              <div
                class="bg_white otherItem clearfix"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <div class="span_One fl">
                  {{ index + 1 }}
                </div>
                <div class="span_Two fl">
                  <div class="nameInfo">
                    <p class="departmentName">{{ item.numbersName }}</p>
                  </div>
                </div>
                <div class="span_Tree fr">
                  <van-image
                    class="img"
                    :src="baseUrl + 'img/rank/proRank_proCount.png'"
                    mode="scaleToFill"
                  >
                  </van-image>
                  {{ item.numbers }}个
                </div>
              </div>
              <div class="loading-p">——我是有底线的——</div>
            </div>
            <div v-else class="nonePage">
              <img :src="baseUrl + 'empty.png'" alt />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
/* eslint-disable */

//饼状
const pieEcharts = () => import("@/views/projectModule/components/pieEcharts");
import { mapState, mapMutations } from "vuex";
export default {
  name: "statisticsPage",
  components: { pieEcharts },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      projectStatus: "projectType", //类型
      radioType: "all",
      rankType: "all",
      chartColumn: null,
      pieData: {
        id: "slflPie",
        chartOption: "",
      },
      echartData: [],
      dataList: [],
    };
  },
  mounted() {
    this.setShowLoad(false);
    this.getEchartData();
    this.getDataList();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    changeType(name) {
      let _this = this;
      if (_this.radioType != "name") {
        _this.radioType = name;
        _this.getEchartData();
      }
    },
    changeRank(name) {
      let _this = this;
      if (_this.rankType != "name") {
        _this.rankType = name;
        _this.getDataList();
      }
    },
    getEchartData() {
      let _this = this;
      _this.$api.project
        .projectTypeRatio({
          dateType: _this.radioType,
          projectType: "DLXM",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data[0]) {
              _this.echartData = [];
              res.data.forEach((item) => {
                let obj = {
                  name: item.numbersName + " " + item.numbers,
                  value: item.amount
                };
                _this.echartData.push(obj);
              });

              _this.setOption();
            }
          } else {
            _this.chartData.rows = [];
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.chartData.rows = [];
          _this.$toast("网络失败,请稍后再试");
        });
    },
    setOption() {
      let _this = this,
        echartNames = [];
      _this.echartData.forEach((item) => {
        echartNames.push(item.name);
      });
      let chartOption = {
        tooltip: {
          trigger: "item",
          formatter: //"{b} {d}%)",
          function(params){
						return params.percent+'%'+params.name  +'个<br>金额:'+ params.value+'元';
					}, 
          textStyle: {fontSize:12 },// 字体大小
        },
        legend: {
          data: echartNames,
          icon: "circle",
          top: "60%",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            rich: {
              a: {
                width: 120, // 每个图例的宽度，具体根据字数调整
                lineHeight: 12,
              },
            },
          },
        },
        series: [
          {
            type: "pie",
            top: "-40%",
            radius: "50%",
            label: {
              // show: false,
              // formatter: "{per|{d}%}\n{b|{b}} ",
              formatter: "{d}%\n{b}",

              // rich: {
              //   a: {
              //     color: "red",
              //     lineHeight: 15,
              //     align: "left",
              //   },
              // },
            },
            // labelLine: {
            //   length: 15,
            // },
            data: _this.echartData,
            itemStyle: {
              normal: {
                borderWidth: 1, //设置每个区域之间的间隔
                borderColor: "#fff", //设置每个区域之间的间隔颜色
              },
            },
          },
        ],
      };
      _this.$set(_this.pieData, "chartOption", chartOption);
    },
    getDataList() {
      let _this = this;
      _this.$api.project
        .projectRegionRank({
          dateType: _this.rankType,
          projectType: "DLXM",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data[0]) {
              _this.dataList = res.data;
            }
          } else {
            _this.$toast(res.msg);
            _this.dataList = [];
          }
        })
        .catch((err) => {
          _this.dataList = [];
          _this.$toast("网络失败,请稍后再试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.statisticsPage {
  height: 100%;
  .van-tabs {
    height: 100%;
    .van-tabs__content {
      height: calc(100% - 45px);
      .van-tab__pane {
        height: 100%;
      }
    }
    .van-tab__text {
      font-size: 17px;
    }

    .van-tab--active {
      .van-tab__text {
        color: #2581d6;
        font-size: 18px;
      }
    }
    .van-tabs__line {
      background-color: #2581d6;
    }
  }
}
</style>
<style lang="less" scoped>
.statisticsPage {
  /*以下是项目类型样式 */
  .selectMain {
    color: #666;
    font-size: 15px;
    position: relative;
    padding: 0 16px;
    margin-top: 10px;
    .radioInfo {
      position: absolute;
      top: -5px;
      right: 16px;
      display: inline-block;
      span {
        display: inline-block;
        padding: 3px 10px;

        font-size: 15px;
        border: 1px solid #2581d6;
        box-sizing: border-box;
      }
      span:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: 0;
      }
      span:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: 0;
      }
      .radioItem {
        background-color: #2581d6;
        color: #fff;
        border: 1px solid #3c78fa;
      }
    }
  }
  .typeInfo {
    height: 100%;
    // padding: 10px 16px 0;
    padding-top: 10px;
    overflow: hidden;
    .infoMain {
      height: calc(100% - 40px);
      padding: 0 16px;
      position: relative;
      margin-top: 20px;
      overflow-y: scroll;
      .pieMian{
        height: 650px;
      }
    }
  }
  /*以下是排行榜样式 */
  .rankInfo {
    height: 100%;
    overflow: hidden;

    padding: 0 16px;
    padding-top: 10px;
    .rank-ul {
      height: calc(100% - 40px);
      margin-top: 5px;
      overflow-y: scroll;
      background-color: #fff;

      .inline {
        display: inline-block !important;
      }

      .otherItem {
        width: 100%;
        position: relative;
        line-height: 45px;
        .span_One {
          font-size: 22px;
          font-family: "DINfunProPlain";
          color: #303030;
          width: 5%;
        }

        .span_Two {
          position: relative;
          width: 65%;
          padding-left: 20px;
          .nameInfo {
            .departmentName {
              font-size: 15px;
              font-family: "PingFangSC-Regular", "PingFang SC";
              color: #343434;
            }
          }
        }

        .span_Tree {
          width: 30%;
          text-align: right;
          .van-image {
            position: absolute;
            top: 50%;
            right: 50px;
            transform: translateY(-50%);
            width: 25px;
            height: 25px;
            border-radius: 50%;
            display: inline-block;
            margin-right: 5px;
          }
          font-size: 15px;
          font-family: "DINfunProPlain";
          color: #27a5fb;
        }
      }
      .loading-p {
        text-align: center;
        color: #666;
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 135px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -67px;
    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>